/*eslint-disable*/
import easydropdown from 'easydropdown'
import generator from 'generate-password'

export default form => {
	$(document).ready(() => {
		let $form = $(form)
		let customerCreateForm = $form.closest('.trade-form-holder').find('form#create_customer')
		let $firstName = customerCreateForm.find('#first_name')
		let $lastName = customerCreateForm.find('#last_name')
		let $email = customerCreateForm.find('#email')
		let $phoneNumber = customerCreateForm.find('#phone')
		let $federalTaxId = customerCreateForm.find('#federal_tax_id')
		let $password = customerCreateForm.find("#password")
		customerCreateForm.attr('target', 'create-customer-iframe')

		$form.find('.industry-dropdown, .state-dropdown').change(e => $(e.target).css('color', 'black'))
		let url = 'https://script.google.com/macros/s/AKfycbxabWmvUcdDsGML2cpjluNUFRNEaopZkSbLGjREftiD6emruPin/exec'
		$form.on('submit', e => {
			e.preventDefault();

			const surveyPost = $.ajax({
				url: url,
				method: "GET",
				dataType: "json",
				data: serializeJqueryObject($form),
				success: data => {
					$('.trade-form-holder').addClass('hide');
					$('.trade-form-holder.thanks').removeClass('hide');
					let formJSON = serializeJqueryObject($form)
					$firstName.val(formJSON["First Name"])
					$lastName.val(formJSON["Last Name"])
					$email.val(formJSON["Email Address"])
					$phoneNumber.val(formJSON["Phone Number"])
					$federalTaxId.val(formJSON["Federal Tax ID"])
					$password.val(generator.generate({ length: 10 }))
					customerCreateForm.trigger('submit')
				},
				error: error => {
					console.error(error)
				}
			})
		})

		const selectMenues = form.querySelectorAll('select')
		selectMenues.forEach((sel, idx)=>{
			if (sel) {
				let edd = easydropdown(sel, {
					behavior: {
						useNativeUiOnMobile: false,
						showPlaceholderWhenOpen: true,
						liveUpdates: true,
					},
					classNames: {
						rootOpenBelow: true,
						rootOpenBelow: 'edd-root-open-below'
					},
					callbacks: {
						onOpen: value => {
							$('.edd-root').removeClass('edd-root-open-above').addClass('edd-root-open-below')
						},
					}
				})
			}
		})
		


		$('.scrollToForm').click((e) => {
			e.preventDefault()
			$('html, body').animate({
				scrollTop: $("#trade #apply").offset().top - 50
			}, 1100)
		})
	})

	const serializeJqueryObject = $form => {
		let obj = {};
		let array = $form.serializeArray();
		array.forEach((entry, idx) => {
			if (obj[entry.name]) {
				if (!obj[entry.name].push) obj[entry.name] = [obj[entry.name]]
				obj[entry.name].push(entry.value || '')
			} else obj[entry.name] = entry.value || ''
		});
		return obj;
	};
}


// WEBPACK FOOTER //
// ./src/scripts/components/trade-form.js